<template>
  <b-card header-tag="header" no-body>
    <template #header>
      <h6 class="mb-0">
        <span class="font-weight-bold">Anexos</span>
      </h6>
    </template>
    <b-card-body>
      <div
        v-for="tipoArquivo in tiposArquivoEvento"
        :key="'arquivoEvento' + tipoArquivo.IdTipoArquivo"
      >
        <b-row v-if="existeArquivo(tipoArquivo.IdTipoArquivo)" class="m-2">
          <b-col cols="6">
            {{ tipoArquivo.IdTipoArquivo + " - " + tipoArquivo.DeTipoArquivo }}
          </b-col>
          <b-col cols="6">
            <div class="d-flex justify-content-center">
              <btn-download
                class="mr-2"
                :fazerDownload="baixarAnexo"
                :parametros="tipoArquivo.IdTipoArquivo"
              />
            </div>
          </b-col>
        </b-row>
      </div>
    </b-card-body>
  </b-card>
</template>

<script lang="ts">
import { UtilsTS } from "@/utilsts";
import { mixins } from "vue-class-component";
import { Component, Vue } from "vue-property-decorator";
import { Evento } from "@/types/eventos/eventos/evento";
import { TipoArquivoEvento } from "@/types/eventos/eventos/tipo-arquivo-evento";
import eventoService from "@/services/licitacoes/eventosService";
import BtnDownload from '@/components/shared/btn-download.vue'


const CompProps = Vue.extend({
  name: "DetalhesAnexosEvento",
  components: { BtnDownload },
  props: {
    evento: {
      type: Evento,
      required: true,
    },
  },
});

@Component
export default class DetalhesAnexosEvento extends mixins(
  UtilsTS,
  CompProps
) {
  tiposArquivoEvento: TipoArquivoEvento[] = []
  
  async mounted() {
    const responseTiposArquivoEvento = await eventoService.listarTiposArquivoEvento()
    this.tiposArquivoEvento = responseTiposArquivoEvento.data
  }

  async baixarAnexo(tipoArquivo: number) {
    const arquivo = this.evento.ArquivoEvento.find(x => x.IdTipoArquivo == tipoArquivo)
    const response = await eventoService.baixarAnexo(arquivo?.IdArquivo)
    this.download(arquivo?.DeNomeArquivo, response.data)
  }

  existeArquivo(tipoArquivo: number) {
    const arquivo = this.evento.ArquivoEvento.find(x => x.IdTipoArquivo == tipoArquivo)
    return arquivo ? true : false
  }
}
</script>

<style></style>